import errors from "consts/metaErrors.json";

export default function (error) {
  const { code } = error;
  const _error = errors.find(error => error.code === code);
  return _error || error;
}